import SearchTerm from "modules/Content/Search/Components/SearchTerm";
import React, { useEffect } from "react";
import styled from "styled-components";
import Input from "../../../Common/Components/Input";
import KeywordSource from "./KeywordSource";
import KeywordSourceV2 from "./KeywordSourceV2";
import { ASSET_TYPE } from "./../../../../constants/index";
import { searchLists, searchPeople } from "../actions";

interface Props {
  handleCampaignNameInput?: any;
  handleOnClickBrowsePeople: any;
  onClickAudienceDone?: any;
  selectedContactNames?: string[];
  selectedContactIds?: any[];
  selectedListNames?: string[];
  selectedListIds?: any[];
  handleAddPeople?: any;
  campaignKeywords?: any[];
  setCampaignKeywords?: any;
  handleOnRemoveCampaignKeyword?: any;
  handleAddSearchTerm?: any;
  setCampaignName?: any;
  assetType?: any;
  campaignName?: string;
  saveAsAsset?: boolean;
}

const NewCampaignModule: React.FC<Props> = (props) => {
  const {
    handleCampaignNameInput,
    handleOnClickBrowsePeople,
    selectedListIds,
    selectedListNames,
    handleAddPeople,
    campaignKeywords,
    setCampaignKeywords,
    handleOnRemoveCampaignKeyword,
    setCampaignName,
    assetType,
    campaignName,
    selectedContactNames,
    selectedContactIds,
    saveAsAsset,
  } = props;
  useEffect(() => {
    if (setCampaignName) {
      return () => {
        setCampaignName("");
      };
    }
  }, []);
  function handleAddSearchTerm(newSearchTerm: string) {
    let newSearchTerms = newSearchTerm.split(",");
    newSearchTerms = newSearchTerms
      .map((word) => word.trim())
      .map((word) => word.toLowerCase().toLowerCase().replace(" and ", " AND "))
      .filter((word) => word !== "");
    if (campaignKeywords) {
      let updatedSearchTerms = Array.from(new Set([...campaignKeywords, ...newSearchTerms]));
      setCampaignKeywords(updatedSearchTerms);
    } else {
      let updatedSearchTerms = Array.from(new Set([...newSearchTerms]));
      setCampaignKeywords(updatedSearchTerms);
    }
    let keywords: string[];
    if (campaignKeywords !== undefined) keywords = [...campaignKeywords, newSearchTerm];
    else keywords = [];
    searchPeople(keywords.toString(), true);
    searchLists(keywords.toString(), true);
  }
  return (
    <Wrapper>
      <Input
        label="Name your new Campaign"
        placeholder="Give this campaign a unique name"
        onChange={handleCampaignNameInput}
        value={campaignName}
        idInput="give-this-campaign-a-unique-name"
      />
      {assetType == ASSET_TYPE.HYBRID && saveAsAsset === false && (
        <KeywordSourceV2
          heading="Keywords to auto-source content:"
          subText="optional"
          desClassName={campaignKeywords && campaignKeywords?.length > 0 ? "mb-s" : ""}
          placeholder={
            campaignKeywords && campaignKeywords?.length > 0
              ? ""
              : "Start typing Keywords to find matching content…"
          }
          desc="Help our Smart Content Engine find the most valuable, relevant and
                timely content for your campaigns and emails automatically."
          searchTerms={campaignKeywords}
          handleAddSearchTerm={handleAddSearchTerm}
          handleOnRemove={handleOnRemoveCampaignKeyword}
        ></KeywordSourceV2>
      )}
      {saveAsAsset === false && (
        <div className="relative-input">
          <span className="browse" onClick={handleOnClickBrowsePeople}>
            Browse
          </span>

          <Input
            label="Add contacts and lists"
            placeholder="Start typing a contact’s or list’s name…"
            optional={true}
            className="d-none" // for hiding input field
          />
          {selectedContactNames && selectedContactIds && selectedContactNames.length > 0 ? (
            <div>
              {selectedContactNames.map((name: any, index: number) => {
                return (
                  <SearchTerm
                    key={index}
                    hideSearchIcon={true}
                    searchTerm={name}
                    onRemove={() => handleAddPeople(selectedContactIds[index], name, "contact")}
                    isExtended={true}
                  />
                );
              })}
            </div>
          ) : null}
          {selectedListNames && selectedListIds && selectedListNames.length > 0 ? (
            <div>
              {selectedListNames.map((name: any, index: number) => {
                return (
                  <SearchTerm
                    key={index}
                    hideSearchIcon={true}
                    searchTerm={name}
                    onRemove={() => handleAddPeople(selectedListIds[index], name, "list")}
                    isExtended={true}
                  />
                );
              })}
            </div>
          ) : null}
        </div>
      )}
    </Wrapper>
  );
};

export default NewCampaignModule;

const Wrapper = styled.div`
  input {
    margin-bottom: 20px;
  }
  transition: ease all 0.1s;
  box-sizing: border-box;
  background: #ecfaf1;
  padding: 1px 30px 30px 30px;
  border-radius: 15px;
  margin: 25px 0;
  float: left;
  width: 100%;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 10px;
  }
  .intro-input {
    color: #5e7079;
    font-size: 14px;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    letter-spacing: -0.38px;
    margin-top: 8px;
  }
  .relative-input {
    position: relative;
    float: left;
    display: block;
    width: 100%;
    .browse {
      font-weight: bold;
      font-size: 12px;
      color: #27ce0a;
      border: 1px solid #27ce0a;
      padding: 2px 8px;
      border-radius: 6px;
      cursor: pointer;
      letter-spacing: 1px;
      position: absolute;
      right: 0;
      top: 22px;
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
        border-radius: 4px;
      }
    }
    input {
      margin-bottom: 0;
    }
  }
`;
